<div class="">
   <div class="contentBox">
      <ul class="brand-details-list team-list font-16">

         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/Prashant-Dugar_jfif.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Prashant Dugar</div>
                  <div class="font-14 light-color proximaNovaSb">Director</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                    Prashant Dugar has ~15 years of experience in private equity and investment banking. He has extensive experience evaluating
                    and executing growth, buyout, and structured deals across various sectors.

               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                    Before joining Mission Holdings in 2021, Prashant was an investment professional at Apollo Global Management’s India fund,
                    AION Capital (a joint venture between Apollo and ICICI). He previously worked as an Associate at Baring Private Equity Asia
                    from 2013 to 2016 and as an Investment Banking Analyst at Morgan Stanley from 2010 to 2013.
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                    Prashant holds an MBA from the Wharton School of the University of Pennsylvania, as well as a master's in finance and a bachelor's
                    degree in business studies from the University of Delhi.
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/jerry.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Jerry Ng</div>
                  <div class="font-14 light-color proximaNovaSb">Director</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Jerry Ng has 20+ years experience in international investment and fund management.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Prior to joining Mission Holdings in 2015, Jerry was Vice President with Everest Capital, a hedge fund
                  specializing in global and emerging markets, from 2008 to 2015. Before his tenure at Everest Capital,
                  Jerry spent 6 years with RBC Dexia Investor Services from 2002 to 2007, where he served in various
                  roles.
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Jerry holds a B.S. (Hons) in Finance from the National University of Ireland.
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/pritish-lrg.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Pritesh Vora</div>
                  <div class="font-14 light-color proximaNovaSb">VP Investments</div>
               </div>
               <!--               <div class="social-media flex">-->
               <!--                  <a href="https://www.linkedin.com/in/nitinseth/" target="_blank" class="icon">-->
               <!--                     <img src="assets/images/twitter.png" alt="">-->
               <!--                  </a>-->
               <!--                  <a href="https://twitter.com/seth_nitin?lang=en" target="_blank" class="icon margin-l-20">-->
               <!--                     <img src="assets/images/linkedin.png" alt="">-->
               <!--                  </a>-->
               <!--               </div>-->
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Pritesh Vora has 25+ years working experience in equity research and operational experience in
                  industrial and energy sectors.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Prior to joining Mission Holdings in 2016, Pritesh was a research analyst at Incedo Inc, specializing
                  in Indian and International equity research. Pritesh spent 6 years from 2006 to 2012 as an adviser
                  with Equanum Advisor Pvt. Ltd, where he was involved in Indian equity research. He started his career
                  at Larsen and Toubro.
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Pritesh holds a B.E. (Hons) in Production Engineering from the University of Bombay and a DME in
                  Mechanical engineering
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/shraddha.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Shraddha Mittal</div>
                  <div class="font-14 light-color proximaNovaSb">VP Mission Ventures</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Shraddha Mittal leads early-stage consumer investing through Mission Ventures.
               </div>
               <div class="wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  She holds an MBA and BA (Hons) from University of Delhi.
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/ivan.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Ivan Lim</div>
                  <div class="font-14 light-color proximaNovaSb">Senior Associate Investments</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Ivan joined Mission Holding Management in 2017 and has over 15 years’ experience span across auditing
                  and assurance, financial accounting, due diligence, and debt financing deals.
               </div>
               <div class="wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  He is currently a Senior Associate where he work collaboratively with the investment team on parts of
                  the investment cycle including deal screening, deal evaluation, due diligence and deal execution. Ivan
                  holds an A.C.C.A. Level 2 qualification.
               </div>
            </div>
         </li>
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/MananPamani.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Manan Pamani</div>
                  <div class="font-14 light-color proximaNovaSb">Senior Analyst</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Manan Pamani is a Senior Analyst in the research team of Mission Capital, which is tasked with
                  overseeing Mission Holdings' liquid capital, invested via direct investments and via external
                  managers.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Prior to joining Mission Holdings in 2018, Manan worked for CRISIL Global Research & Analytics
                  (subsidiary of S&P) and E-Valueserve as an Industrial and Utilities analyst supporting global
                  sell-side banks.
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  He holds an MBA from Nirma University and a Computer Engineering degree from Gujarat University.
                  Additionally, he has also passed CFA level 3.
               </div>
            </div>
         </li>
      </ul>
   </div>
</div>
